import { render, staticRenderFns } from "./abnormalinfo.vue?vue&type=template&id=121c1bc0&scoped=true&"
import script from "./abnormalinfo.vue?vue&type=script&lang=js&"
export * from "./abnormalinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c1bc0",
  null
  
)

export default component.exports